import React, { FC, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, Grid } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useCommonStyles } from 'src/styles';
import { CustomDialogTitle, FieldLabel } from 'src/components';
import { useStyles } from './styles';

export interface Props {
  open: boolean;
  translation: any;
  groupBy: string;
  onClose: () => void;
  applyFilter: (groupBy: string) => void;
}

export const FiltersDialog: FC<Props> = ({ open, groupBy, translation, onClose, applyFilter }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [groupedBy, setGroupedBy] = useState<string>('');

  const applyNewFilter = () => {
    applyFilter(groupedBy);
  };

  const clearFilter = () => {
    applyFilter('');
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    setGroupedBy(groupBy);
  }, [groupBy]);

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.filters} onClose={() => onClose()} />
      <Grid container direction="column">
        <FieldLabel label={translation.text_5718} />
        <Grid container direction="row" alignContent="flex-start" alignItems="center" className={classes.groupByContainer}>
          <Grid item xs={4}>
            <Button
              className={groupedBy === 'partnership' ? classes.selectedGroup : ''}
              classes={{
                root: classes.partnership,
              }}
              onClick={() => setGroupedBy('partnership')}
            >
              {translation.text_6625}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              className={groupedBy === 'clientName' ? classes.selectedGroup : ''}
              classes={{
                root: classes.currency,
              }}
              onClick={() => setGroupedBy('clientName')}
            >
              {translation.text_6635}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              className={groupedBy === 'login' ? classes.selectedGroup : ''}
              classes={{
                root: classes.country,
              }}
              onClick={() => setGroupedBy('login')}
            >
              {translation.text_6643}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button onClick={applyNewFilter} fullWidth startIcon={<Check />} className={commonClasses.activeDialogBtn}>
          {translation.text_65}
        </Button>
        <Button onClick={clearFilter} fullWidth startIcon={<Close />} className={commonClasses.cancelDialogBtn}>
          {translation.clearAll}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
